<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <!-- Recent transactions -->
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header d-flex align-items-center justify-content-between">
            <h2>Country List</h2>
          </div>
          <div class="body pt-0">
            <div
              class="chart-top-action d-md-flex justify-content-between py-3"
            >
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-md-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search country"
                    aria-label="Search country"
                    aria-describedby="search-country"
                    v-model="searchText"
                    v-on:keyup.enter="refreshCountryTable"
                  />
                  <div
                    class="input-group-append"
                    @click="refreshCountryTable()"
                  >
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <b-modal id="addCountry_model" hide-footer>
              <template #modal-title>
                <h5 class="text-primary font-weight-normal mb-0">
                  Add Country
                </h5>
              </template>
              <div class="modal-area">
                <ValidationObserver v-slot="{ passes }">
                  <form @submit.prevent="passes(addCountrySubmit)">
                    <ValidationProvider
                      name="name"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addcountry.name,
                          success: addcountry.name,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addcountry.name"
                            class="form-control"
                            id="name"
                            placeholder="Country Name"
                          />
                          <label for="name" class="control-label">
                            Country Name*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addcountry.name"
                          ></i>
                          <i class="fa fa-check" v-if="addcountry.name"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="code"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addcountry.code,
                          success: addcountry.code,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addcountry.code"
                            class="form-control"
                            id="code"
                            placeholder="Country Code"
                          />
                          <label for="code" class="control-label">
                            Country Code*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addcountry.code"
                          ></i>
                          <i class="fa fa-check" v-if="addcountry.code"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="currency"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !addcountry.currency,
                          success: addcountry.currency,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="addcountry.currency"
                            class="form-control"
                            id="currency"
                            placeholder="Country Currency"
                          />
                          <label for="currency" class="control-label">
                            Country Currency*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !addcountry.currency"
                          ></i>
                          <i class="fa fa-check" v-if="addcountry.currency"></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <div
                      class="d-flex flex-column flex-md-row justify-content-center"
                    >
                      <b-button
                        variant="secondary btn-mw"
                        size="lg"
                        @click="$bvModal.hide('addCountry_model')"
                      >
                        Cancel
                      </b-button>
                      <b-button
                        type="submit"
                        variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                        size="lg"
                      >
                        Submit
                      </b-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </b-modal>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="countryTable"
              responsive
              hover
              outlined
              table-class="js-basic-example table-custom mb-0"
              head-variant="light"
              :items="getCountryData"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :emptyText="'No data found.'"
              show-empty
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(uuid)="data">
                <b-button
                  id="button1"
                  variant="outline-primary"
                  size="sm"
                  v-b-tooltip.hover
                  :data-original-title="data.value.countryid"
                  :title="data.value.countryid"
                  @click.prevent="copyTooltip($event)"
                >
                  <i class="fa fa-2x fa-barcode"></i>
                </b-button>
              </template>
              <template #cell(details)="data">
                <div class="align-items-center d-flex">
                  <span :class="data.value.flagClass" class="mr-2"></span>
                  <span>{{ data.value.name }}</span>
                </div>
              </template>
              <template #cell(domestic)="data">
              <!--  v-if="$store.getters['authpermission/hasAnyPermission'](['country.status'])" -->
                <div class="custom-switch success-bg">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="data.value.id"
                    :checked="data.value.isChecked"
                    :disabled="!$store.getters['authpermission/hasAnyPermission'](['country.status'])"
                    @click="$store.getters['authpermission/hasAnyPermission'](['country.status']) && updateStatus($event, 'domestic', data)"
                  />
                  <!-- @click="updateStatus($event, 'domestic', data)" -->
                  <label class="custom-switch-label" :for="data.value.id">
                    <span class="custom-switch-text1">Yes</span>
                    <span class="custom-switch-text2">No</span>
                  </label>
                </div>
              </template>
              <template #cell(destination)="data">
                <div class="custom-switch success-bg">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="data.value.id"
                    :checked="data.value.isChecked"
                    :disabled="!$store.getters['authpermission/hasAnyPermission'](['country.status'])"
                    @click="$store.getters['authpermission/hasAnyPermission'](['country.status']) && updateStatus($event, 'destination', data)"
                  />
                  <!-- @click="updateStatus($event, 'destination', data)" -->
                  <label class="custom-switch-label" :for="data.value.id">
                    <span class="custom-switch-text1">Yes</span>
                    <span class="custom-switch-text2">No</span>
                  </label>
                </div>
              </template>
              <template #cell(crossborder)="data">
                <div class="custom-switch success-bg">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="data.value.id"
                    :checked="data.value.isChecked"
                    :disabled="!$store.getters['authpermission/hasAnyPermission'](['country.status'])"
                    @click="$store.getters['authpermission/hasAnyPermission'](['country.status']) && updateStatus($event, 'crossborder', data)"
                  />
                  <!-- @click="updateStatus($event, 'crossborder', data)" -->
                  <label class="custom-switch-label" :for="data.value.id">
                    <span class="custom-switch-text1">Yes</span>
                    <span class="custom-switch-text2">No</span>
                  </label>
                </div>
              </template>
              <template #cell(isblacklisted)="data">
                <div class="custom-switch success-bg">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="data.value.id"
                    :checked="data.value.isChecked"
                    :disabled="!$store.getters['authpermission/hasAnyPermission'](['country.status'])"
                    @click="$store.getters['authpermission/hasAnyPermission'](['country.status']) && updateStatus($event, 'isblacklisted', data)"
                  />
                  <!-- @click="updateStatus($event, 'isblacklisted', data)" -->
                  <label class="custom-switch-label" :for="data.value.id">
                    <span class="custom-switch-text1">Yes</span>
                    <span class="custom-switch-text2">No</span>
                  </label>
                </div>
              </template>
              <template #cell(autopayenabled)="data">
                <div class="custom-switch success-bg">
                  <input
                    type="checkbox"
                    class="custom-switch-input"
                    :id="data.value.id"
                    :checked="data.value.isChecked"
                    :disabled="!$store.getters['authpermission/hasAnyPermission'](['country.status'])"
                    @click="$store.getters['authpermission/hasAnyPermission'](['country.status']) && updateStatus($event, 'autopayenabled', data)"
                  />
                  <label class="custom-switch-label" :for="data.value.id">
                    <span class="custom-switch-text1">Yes</span>
                    <span class="custom-switch-text2">No</span>
                  </label>
                </div>
              </template>
              <!-- <template #cell(mm_autopay_max_limit)="data">
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="data.value.value"
                    :readonly="!data.value.editing"
                    @input="enforceDecimalLimit(data)"
                    style="max-width: 150px"
                  />
                  <i
                    class="mr-1 fa fa-edit text-info cursor-pointer"
                    v-if="!data.value.editing"
                    @click="data.value.editing = true"
                  ></i>
                  <i
                    class="mr-1 fa fa-save text-success cursor-pointer"
                    v-if="data.value.editing"
                    @click="saveMaxLimit(data)"
                  ></i>
                </div>
              </template> -->
              <template #cell(show_details)="data" v-if="$store.getters['authpermission/hasAnyPermission'](['country.details'])">
                <b-button
                  variant="primary"
                  size="sm"
                  @click="setCountry(data)"
                  v-b-tooltip.hover
                  title="View/Edit Payout Options"
                >
                  <i class="fa fa-cog"></i> Configure
                </b-button>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader ref="loader"></main-loader>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import shared from "@/shared.js";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  name: "country-component",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      isVisibleFilter: false,

      //Recent transactions table data
      items: [],

      //Recent transactions table header
      fields: [
        { key: "uuid", label: "UUID", sortable: true, thClass: "th_sortfix" },
        {
          key: "details",
          label: "Name",
          sortable: true,
          thClass: "th_sortfix",
        },
        // { key: 'isocode', label: 'Alpha-2'},
        // { key: 'isocode3', label: 'Alpha-3'},
        // { key: 'numeric', label: 'Numeric' },
        { key: "dialcode", label: "Dialling Code" },
        { key: "currency", label: "Currency" },
        { key: "domestic", label: "Domestic" },
        { key: "crossborder", label: "Cross Border" },
        { key: "destination", label: "Destination" },
        { key: "isblacklisted", label: "Blacklist" },
        { key: "autopayenabled", label: "AutoPay Enabled" },
        // {
        //   key: "mm_autopay_max_limit",
        //   label: "MoMo Autopay MAX Transfer Limit",
        // },
        { key: "show_details", label: "Actions", thStyle: "width:150px" },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      //Recent transactions table pagination
      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      searchText: "",
      businessId: "",
      countryitems: [],
      addcountry: {
        name: "",
        code: "",
        currency: "",
      },
    };
  },
  methods: {
    addCountrySubmit() {
      console.log(this.addcountry);
    },
    //Recent transactions table go to pagination
    onEnter(e) {
      var paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = e.target.value;
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },

    //Recent transactions table Details copy
    copyTooltip: function (e) {
      var tooltipText = e.currentTarget.getAttribute("data-original-title");
      const inputCopyText = document.createElement("input");
      inputCopyText.value = tooltipText;
      document.body.appendChild(inputCopyText);
      inputCopyText.select();
      document.execCommand("copy");
      document.body.removeChild(inputCopyText);
    },

    updateStatus(event, key, row) {
      // Do nothing if user lacks permission
      if (!this.$store.getters['authpermission/hasAnyPermission'](['country.status'])) {
        return;
      }

      // Prevent being able to enable autopaywithout a valid limit
      const isEnablingAutopay = key === "autopayenabled" && !row.item.autopayenabled.isChecked && event.target.checked;
      const hasAutopayLimit = row.item.mm_autopay_max_limit && Number(row.item.mm_autopay_max_limit.value) > 0;

      if (isEnablingAutopay && !hasAutopayLimit) {
        event.preventDefault();
        shared.toastrError('Cannot enable autopay: valid mobile money autopay limit is required');
        return;
      }

      this.$refs.loader.show();
      // console.log(event.target.checked, key, row);
      let dataJson = {
        domestic:
          key === "domestic"
            ? event.target.checked
            : row.item.domestic.isChecked,
        crossborder:
          key === "crossborder"
            ? event.target.checked
            : row.item.crossborder.isChecked,
        destination:
          key === "destination"
            ? event.target.checked
            : row.item.destination.isChecked,
        blacklisted:
          key === "isblacklisted"
            ? event.target.checked
            : row.item.isblacklisted.isChecked,
        autopayenabled:
          key === "autopayenabled"
            ? event.target.checked
            : row.item.autopayenabled.isChecked,
      };
      /* if(key==='crossborder'){
                dataJson.domestic = true;
                dataJson.destination = true;
            }*/
      this.$http
        .put(this.$baseurl + "country/" + row.item.countryid, dataJson, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("jwtToken"),
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.code == "0003-000") {
            this.refreshCountryTable();
            shared.toastrSuccess(res.data.message);
            this.$refs.loader.hide();
          } else {
            this.refreshCountryTable();
            this.$refs.loader.hide();
          }
        })
        .catch((error) => {
          // console.log(error.response);
          // Special handling for autopay enable error
          if (isEnablingAutopay &&
              error.response &&
              error.response.status === 400 &&
              error.response.data.code === "V0003-010") {
            // Don't refresh table to keep toggle in disabled state
            this.$refs.loader.hide();
            shared.toastrError(error.response.data.message);
          } else {
            this.refreshCountryTable();
            this.$refs.loader.hide();
            shared.toastrError(error.response.data.message);
          }
        });
    },

    async getCountryData(ctx) {
      try {
        this.$refs.loader.show();
        let page = "";
        let size = "";
        let sortby = "";
        let sort = false;
        if (ctx.currentPage != undefined) {
          page = ctx.currentPage;
        } else {
          page = 1;
        }
        if (ctx.perPage != undefined) {
          size = ctx.perPage;
        } else {
          size = 50;
        }
        if (ctx.sortBy == "") {
          sortby = "createdat";
        } else {
          sortby = ctx.sortBy;
        }
        if (ctx.sortDesc == false) {
          sort = "asc";
        } else {
          sort = "desc";
        }

        this.currentPageJump = page;
        this.items = [];
        let paramData = {
          sort: sort,
          sortby: sortby,
          size: size,
          page: page,
          search: this.searchText,
        };
        const queryString = new URLSearchParams(paramData).toString();
        const token = localStorage.getItem("jwtToken");
        const response = await this.$http.get(
          this.$baseurl + "country/list?" + queryString,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          },
        );
        // JSON responses are automatically parsed.
        // console.log('test',this.countryitems);
        response.data.details.map((item, index) => {
          let domesticStatus = "";
          let crossborder = "";
          let destination = "";
          let blacklist = "";

          if (this.countryitems.some((el) => el.countryID === item.countryid)) {
            // console.log(item.countryname);
            this.countryitems.some((el) => {
              // console.log(el);
              if (el.countryID === item.countryid) {
                //code here
                domesticStatus = el.domestic;
                crossborder = el.crossborder;
                destination = el.destination;
                blacklist = el.isblacklisted;
              }
            });
          } else {
            domesticStatus = item.domestic;
            crossborder = item.crossborder;
            destination = item.destination;
            blacklist = item.isblacklisted;
          }

          let lists = {
            uuid: { countryid: item.countryid },
            countryid: item.countryid,
            details: {
              id: item.countryid,
              name: item.countryname,
              flagClass:
                "flag-icon flag-icon-" +
                item.isocode.toLowerCase() +
                " fi-md fi-round",
            },
            countryIsoCode: item.isocode,
            isocode: item.alpha2,
            isocode3: item.alpha3,
            currency: item.currencycode,
            numeric: item.isonumeric,
            dialcode: item.mobilecountrycode,
            domestic: {
              id: "domestic_" + index,
              isChecked: domesticStatus,
              countryId: item.countryid,
            },
            destination: {
              id: "destination_" + index,
              isChecked: destination,
              countryId: item.countryid,
            },
            crossborder: {
              id: "crossborder_" + index,
              isChecked: crossborder,
              countryId: item.countryid,
            },
            isblacklisted: {
              id: "isblacklisted_" + index,
              isChecked: blacklist,
              countryId: item.countryid,
            },
            autopayenabled: {
              id: "autopayenabled_" + index,
              isChecked: item.autopayenabled,
              countryId: item.countryid,
            },
            mm_autopay_max_limit: {
              value: item.mm_autopay_max_limit,
              editing: false,
              countryId: item.countryid,
            },
            show_details: "",
          };
          /* if(crossborder){
                        lists.domestic = {id:'domestic_'+index,isChecked:crossborder,countryId:item.countryid};
                        lists.destination= {id:'domestic_'+index,isChecked:crossborder,countryId:item.countryid};
                    }*/
          this.items.push(lists);
        });
        this.totalRows = response.data.query.total;
        this.$refs.loader.hide();
        return this.items;
      } catch (error) {
        console.log(error);
        this.$refs.loader.hide();
      }
    },

    refreshCountryTable() {
      // console.log('refresh');
      // this.fintechbusiness(this.businessId);
      this.$refs.countryTable.refresh();
    },

    setCountry(data) {
      // console.log('Set',data);
      localStorage.setItem("countryId", data.item.countryid);
      localStorage.setItem("countryName", data.item.details.name);
      localStorage.setItem("countryCode", data.item.countryIsoCode);
      localStorage.setItem("countryCurrency", data.item.currency);
      localStorage.setItem("countryDomestic", data.item.domestic.isChecked);
      localStorage.setItem(
        "countryDestination",
        data.item.destination.isChecked,
      );
      localStorage.setItem(
        "countryCrossborder",
        data.item.crossborder.isChecked,
      );
      this.$router.push({ path: "/country/details" });
    },

    async fintechbusiness(businessid) {
      try {
        this.countryitems = [];
        const response = await this.$http.get(
          this.$baseurl + "countries/fintech/" + businessid,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("jwtToken"),
            },
          },
        );
        // JSON responses are automatically parsed.
        // console.log(response);
        response.data.details.map((item) => {
          let countryLists = {
            countryID: item.countryid,
            businessID: item.businessid,
            domestic: item.domestic,
            destination: item.destination,
            crossborder: item.crossborder,
            isblacklisted: item.isblacklisted,
            autopayenabled: item.autopayenabled,
          };
          this.countryitems.push(countryLists);
        });
        return this.countryitems;
      } catch (error) {
        console.log(error);
      }
    },

    saveMaxLimit(data) {
      this.$refs.loader.show();

      // Validate that the value is not 0 or negative
      let limitValue = parseFloat(data.value.value);
      if (isNaN(limitValue) || limitValue <= 0) {
        shared.toastrError(
          "MoMo Autopay MAX Transfer Limit must be greater than 0",
        );
        this.$refs.loader.hide();
        return;
      }

      let payload = {
        mm_autopay_max_limit: limitValue,
      };
      this.$http
        .put(this.$baseurl + "country/" + data.item.countryid, payload, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("jwtToken"),
          },
        })
        .then((res) => {
          if (res.data.code == "0003-000") {
            shared.toastrSuccess(res.data.message);
          } else {
            shared.toastrError(res.data.message);
          }
          data.value.editing = false;
          this.refreshCountryTable();
          this.$refs.loader.hide();
        })
        .catch((error) => {
          this.refreshCountryTable();
          this.$refs.loader.hide();
          shared.toastrError(error.response.data.message);
        });
    },

    enforceDecimalLimit(data) {
      let value = data.value.value;

      // Remove invalid characters (only allow digits and one decimal point)
      value = value.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point remains
      const firstDot = value.indexOf(".");
      if (firstDot !== -1) {
        // Keep only first dot, remove subsequent dots
        value =
          value.substring(0, firstDot + 1) +
          value.substring(firstDot + 1).replace(/\./g, "");
      }

      // Handle empty string
      if (value === "") {
        data.value.value = "";
        return;
      }

      const parts = value.split(".");
      let intPart = parts[0];
      let decPart = parts[1] || "";

      // For decimal(15,2): total digits = 15, decimal places = 2
      // So integer part can be up to 13 digits (15 - 2 = 13)
      if (intPart.length > 13) {
        intPart = intPart.substring(0, 13);
      }

      // Limit decimal part to 2 digits
      if (decPart.length > 2) {
        decPart = decPart.substring(0, 2);
      }

      // Reconstruct the value
      if (decPart.length > 0 || value.includes(".")) {
        value = `${intPart}.${decPart}`;
      } else {
        value = intPart;
      }

      // Use Vue.set to ensure reactivity (or direct assignment should work in Vue 2)
      this.$set(data.value, "value", value);
    },
  },
  mounted() {
    if (localStorage.getItem("businessID")) {
      this.businessId = localStorage.getItem("businessID");
      this.fintechbusiness(this.businessId);
    }
  },
};
</script>

<style>
/* .flag-align{
    bottom: -4px;
} */
</style>
